import { useState, useEffect } from "react";
import { MainLayout } from "../components/Layout";
import { adminAPI } from "../lib/api";
import { Activity } from "lucide-react";

export default function ActivityPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAPI.getActivityLogs(100)
      .then(function(res) {
        setLogs(res.data);
        setLoading(false);
      })
      .catch(function(err) {
        console.error(err);
        setLoading(false);
      });
  }, []);

  function formatAction(action) {
    if (action === "login") return "Connexion";
    if (action === "create") return "Création";
    if (action === "update") return "Modification";
    if (action === "delete") return "Suppression";
    if (action === "pay") return "Paiement";
    return action;
  }

  function formatEntity(entity) {
    if (entity === "client") return "Client";
    if (entity === "repair") return "Réparation";
    if (entity === "part") return "Pièce";
    if (entity === "invoice") return "Facture";
    if (entity === "employee") return "Employé";
    if (entity === "user") return "Utilisateur";
    return entity;
  }

  function formatDate(dateStr) {
    return new Date(dateStr).toLocaleString('fr-FR');
  }

  if (loading) {
    return (
      <MainLayout>
        <div className="text-center py-12 text-muted-foreground">Chargement...</div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="space-y-6" data-testid="activity-page">
        <div>
          <h1 className="font-chivo text-3xl font-bold text-foreground">Journal d'activité</h1>
          <p className="text-muted-foreground mt-1">Historique des actions</p>
        </div>

        {logs.length === 0 ? (
          <div className="text-center py-12 text-muted-foreground">
            <Activity className="w-12 h-12 mx-auto mb-4 opacity-50" />
            <p>Aucune activité</p>
          </div>
        ) : (
          <div className="bg-card border border-border rounded-md overflow-hidden">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Utilisateur</th>
                  <th>Action</th>
                  <th>Type</th>
                  <th>Détails</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(function(log, idx) {
                  return (
                    <tr key={log.id || idx}>
                      <td className="font-medium">{log.user_name}</td>
                      <td>{formatAction(log.action)}</td>
                      <td>
                        <span className="px-2 py-1 bg-secondary text-xs rounded">
                          {formatEntity(log.entity_type)}
                        </span>
                      </td>
                      <td className="text-muted-foreground">{log.details || '-'}</td>
                      <td className="text-muted-foreground text-sm">{formatDate(log.created_at)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </MainLayout>
  );
}
